import { Button } from '@mui/material';

import { apiPost, AppModels, AppState, DrivePDFMimeType, isErrorResponse, jsonPost, PlanDocumentAttrs, planDocumentSlice, ProjectDataAttrs, projectDataSelector, projectDataSlice, ProjectDataState, saveModel } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { appStore } from '../../store';
import { GoogleFileFolderSelector, GoogleFinderMode } from '../googledrive/GoggleFileSystem';

export const ProjectTestView = (props: { projectId: ModelId; }) => {

    const [updloadFile, setUploadFile] = React.useState<File | undefined>();

    const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, props.projectId));

    const [selectGoogleFile, setSelectGoogleFile] = React.useState(false);

    const rafraichirGoogleDriveData = async () => {
        if (projectData && projectData.driveFileId) {
            await saveModel(AppModels.projectDatas, { id: projectData.id, state: ProjectDataState.WAITING });
        }
    };

    React.useEffect(() => {
        if (updloadFile) {

            uploadProjectDataFile();

        }
    }, [updloadFile]);

    const uploadProjectDataFile = async () => {
        if (updloadFile) {
            const data = new FormData();

            data.append('files', updloadFile);
            const xhr = new XMLHttpRequest();
            const response: any | ProjectDataAttrs = await new Promise((resolve) => {
                xhr.upload.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        console.log("upload progress:", event.loaded / event.total);
                    }
                });
                xhr.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {

                    }
                });
                xhr.addEventListener("loadend", () => {
                    resolve(xhr.readyState === 4 && xhr.status === 200 ? JSON.parse(xhr.response) : 'Erreur');
                    setUploadFile(undefined);
                });
                xhr.open("POST", '/project/' + props.projectId + '/uploadprojectpdf', true);
                xhr.send(data);
            });
            if (isErrorResponse(response)) {
                alert('Une erreur a eu lieu');
            } else if ('error' in response) {
                appStore.dispatch(planDocumentSlice.actions.upsertOne(response as PlanDocumentAttrs));
            } else {
                alert('Impossible de télécharger');
            }
            console.log('response', response);
        }
    };

    return <>
        <Button onClick={() => { setSelectGoogleFile(true); }}>Sélectionner le document Excel dans Google Drive</Button>
        {projectData && projectData.driveFileId && <Button onClick={() => { rafraichirGoogleDriveData; }}>Rafraichir les données</Button>}
        <Button variant='contained' onClick={async () => {
            jsonPost('/project/dotest', { projectId: 1, driveFileId: '18O2shkzn7S4AY7fNsv_Ef1rswU4lTypa' });
        }}>TEST</Button>
        <input
            accept={DrivePDFMimeType}
            style={{ display: 'none' }}
            id="upload-pdf"
            multiple
            type="file"
            onChange={(event) => setUploadFile(event.target.files?.[0])}
        />
        <label htmlFor="upload-pdf">
            <Button variant="contained" component="span">
                Téléverser
            </Button>
        </label>
        {selectGoogleFile && <GoogleFileFolderSelector onFileSelected={async file => {
            console.log('file', file);
            if (file) {
                const response = await apiPost('projectSetDataFromGoogleDriveFile', { projectId: props.projectId, driveFileId: file.id });
                appStore.dispatch(projectDataSlice.actions.upsertOne(response));
                console.log('response', response);
            }
            setSelectGoogleFile(false);

        }} mode={GoogleFinderMode.SELECT_PDF} />}
    </>;
};
